// Dati aziendali e configurazione del sito — aggiorna qui i recapiti reali
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// URL pubblico dell'applicazione gestionale Supernova esistente (Area Partner)
export const PARTNER_URL = process.env.REACT_APP_PARTNER_URL || "";

export const COMPANY = {
  name: "SUPERNOVA",
  network: "ENERGY NETWORK",
  tagline: "Energia · Gas · Rete",
  legal: "Supernova Energy Network S.r.l. · P.IVA 00000000000 · Sede Legale: Italia", // segnaposto
  email: "info@supernovaenergy.it", // segnaposto
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1677926405168-fa86268b7295?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxkYXJrJTIwY2luZW1hdGljJTIwY29zbWljJTIwbmVidWxhfGVufDB8fHx8MTc4NTQxMzgxMnww&ixlib=rb-4.1.0&q=85",
  pillar1: "https://images.pexels.com/photos/4546269/pexels-photo-4546269.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  pillar2: "https://images.pexels.com/photos/18316988/pexels-photo-18316988.jpeg",
  pillar3: "https://images.unsplash.com/photo-1707157281599-d155d1da5b4c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGFkdmlzb3IlMjBhbmFseXppbmclMjBjaGFydHN8ZW58MHx8fHwxNzkxOTk2OTY1fDA&ixlib=rb-4.1.0&q=85",
  fullbleed: "https://images.unsplash.com/photo-1567095751004-aa51a2690368?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxkYXJrJTIwY2luZW1hdGljJTIwY29zbWljJTIwbmVidWxhfGVufDB8fHx8MTc4NTQxMzgxMnww&ixlib=rb-4.1.0&q=85",
};
